"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityProfileDocumentDto = instanceOfFacilityProfileDocumentDto;
exports.FacilityProfileDocumentDtoFromJSON = FacilityProfileDocumentDtoFromJSON;
exports.FacilityProfileDocumentDtoFromJSONTyped = FacilityProfileDocumentDtoFromJSONTyped;
exports.FacilityProfileDocumentDtoToJSON = FacilityProfileDocumentDtoToJSON;
exports.FacilityProfileDocumentDtoToJSONTyped = FacilityProfileDocumentDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityProfileDocumentDto interface.
 */
function instanceOfFacilityProfileDocumentDto(value) {
    if (!('href' in value) || value['href'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    return true;
}
function FacilityProfileDocumentDtoFromJSON(json) {
    return FacilityProfileDocumentDtoFromJSONTyped(json, false);
}
function FacilityProfileDocumentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'href': json['href'],
        'mimeType': json['mimeType'],
        'profileId': json['profileId'],
        'fileName': json['fileName'],
    };
}
function FacilityProfileDocumentDtoToJSON(json) {
    return FacilityProfileDocumentDtoToJSONTyped(json, false);
}
function FacilityProfileDocumentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'href': value['href'],
        'mimeType': value['mimeType'],
        'profileId': value['profileId'],
        'fileName': value['fileName'],
    };
}
//# sourceMappingURL=FacilityProfileDocumentDto.js.map